export default "__VITE_ASSET__q54hBMhx__"